import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { 
  LogOut,
  ChevronDown
} from 'lucide-react';
import { useAuthStore } from '../stores/authStore';
import VehicleManagement from './fleet/VehicleManagement';
import DriverManagement from './fleet/DriverManagement';
import RouteManagement from './fleet/RouteManagement';
import JobManagement from './fleet/JobManagement';
import TripReplay from './fleet/TripReplay';
import TripPlanning from './fleet/TripPlanning';
import FleetMap from './fleet/FleetMap';
import IturanLiveMap from './fleet/IturanLiveMap';
import logo from '../assets/logo.jpg';

const Dashboard: React.FC = () => {
  const { user, logout, isCompanyStaff } = useAuthStore();
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="min-h-screen bg-fleet-light">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200 relative z-50">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            {/* Logo */}
            <div className="flex items-center">
              <img src={logo} alt="Logo" className="h-10 w-auto" />
            </div>

            {/* User Menu */}
            <div className="relative">
              <button
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex items-center space-x-3 text-fleet-dark hover:text-fleet-primary transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <div className="h-8 w-8 rounded-full bg-fleet-secondary flex items-center justify-center">
                    <span className="text-white font-medium text-sm">
                      {user?.name?.charAt(0) || 'U'}
                    </span>
                  </div>
                  <span className="text-sm font-medium hidden sm:block">
                    Welcome, {user?.name || 'User'}
                  </span>
                  <ChevronDown className="h-4 w-4" />
                </div>
              </button>

              {/* Dropdown Menu */}
              {dropdownOpen && (
                <>
                  <div 
                    className="fixed inset-0 z-[9999]" 
                    onClick={() => setDropdownOpen(false)}
                  />
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 py-1 z-[10000]">
                    <div className="px-4 py-2 border-b border-gray-200">
                      <p className="text-sm font-medium text-fleet-dark">{user?.name}</p>
                      <p className="text-xs text-fleet-neutral">{user?.email}</p>
                    </div>
                    <button
                      onClick={handleLogout}
                      className="w-full text-left px-4 py-2 text-sm text-fleet-dark hover:bg-gray-100 flex items-center"
                    >
                      <LogOut className="h-4 w-4 mr-2" />
                      Sign out
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<IturanLiveMap />} />
          <Route path="/ituran-live" element={isCompanyStaff() ? <IturanLiveMap /> : <Navigate to="/dashboard" replace />} />
          <Route path="/map" element={isCompanyStaff() ? <FleetMap /> : <Navigate to="/dashboard" replace />} />
          <Route path="/trips" element={<div className="p-6">{isCompanyStaff() ? <TripPlanning /> : <Navigate to="/dashboard" replace />}</div>} />
          <Route path="/vehicles" element={<div className="p-6"><VehicleManagement /></div>} />
          <Route path="/drivers" element={<div className="p-6">{isCompanyStaff() ? <DriverManagement /> : <Navigate to="/dashboard" replace />}</div>} />
          <Route path="/routes" element={<div className="p-6">{isCompanyStaff() ? <RouteManagement /> : <Navigate to="/dashboard" replace />}</div>} />
          <Route path="/jobs" element={<div className="p-6"><JobManagement /></div>} />
          <Route path="/replay" element={<div className="p-6">{isCompanyStaff() ? <TripReplay /> : <Navigate to="/dashboard" replace />}</div>} />
          <Route path="/settings" element={<div className="p-6"><div>Settings Component</div></div>} />
        </Routes>
      </main>
    </div>
  );
};

export default Dashboard;